import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import init, { InitParams } from "./initializations";

const initParams: InitParams = {
  reactVersion: React,
  reactDomVersion: ReactDOM,
};

init(initParams);

export default function Root() {
  return <App />;
}
